import React, { Component } from 'react';
import { Card, DropdownMenu, ListItem, Switch } from 'react-md';
import ReactEcharts from 'react-echarts-component';
import ZDropdownMenu from '../Utility/ZDropdownMenu';
import MetricsCardItem from './MetricsCardItem';
import MetricsSortItem from './MetricsSortItem';
import MetricsFilterItem from './MetricsFilterItem';
import MetricsChartMenuItem from './MetricsChartMenuItem';
import MetricsEngageErrorItem from './MetricsEngageErrorItem';
import MetricsGoalItem from './MetricsGoalItem';
import MetricsContestItem from './MetricsContestItem';
import ChartHelper from '../Helper/ChartHelper';
import AdvertisementService from '../../services/AdvertisementService';

export default class MetricsViewRight extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeChart: "rollup",
            chartHidden: window.localStorage.chartHidden != undefined ? (window.localStorage.chartHidden === 'true') : false,
            contentId: -1,
            adImage: "",
            adLink: "",
            expandedGoal: null,
            expandedContest: null,
        }

        this.chartHelper = new ChartHelper();
        this.adService = new AdvertisementService();

        this.chartSwitch = true;
        this.goalSwitch = true;
        this.contestSwitch = true;
        this.clipboardSwitch = true;
        this.peekSwitch = true;

        this.expandGoal = this.expandGoal.bind(this);
        this.expandContest = this.expandContest.bind(this);

        this.chartExists = this.chartExists.bind(this);
        this.numberWithCommas = this.numberWithCommas.bind(this);
        this.convertToDisplay = this.convertToDisplay.bind(this);

        this.handleChangeChart = this.handleChangeChart.bind(this);
        this.toggleChartHidden = this.toggleChartHidden.bind(this);
        this.generateGoalItems = this.generateGoalItems.bind(this);
        this.generateContestItems = this.generateContestItems.bind(this);
        this.generateClipboard = this.generateClipboard.bind(this);
        this.generatePeek = this.generatePeek.bind(this);
        this.openAdLink = this.openAdLink.bind(this);
        this.generateNoContentMessage = this.generateNoContentMessage.bind(this);

        let self = this;
        // self.adService.getContent((content) => {
        //     self.setState({ contentId: content.contentId, adImage: content.imageUrl, adLink: content.linkUrl });
        //     self.advertisementInterval = setInterval(() => {

        //         if (!window.zzIsPaused && !this.props.isPhone) {
        //             self.adService.getContent((content) => {
        //                 self.setState({ contentId: content.contentId, adImage: content.imageUrl, adLink: content.linkUrl });
        //             });
        //         }
        //     }, 30000);
        // });
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {
        clearInterval(this.advertisementInterval);
    }

    expandGoal(goal) {
        this.setState({ expandedGoal: (this.state.expandedGoal === null ? goal : (this.state.expandedGoal.goalId === goal.goalId ? null : goal)) });
    }

    expandContest(contest) {
        this.setState({ expandedContest: (this.state.expandedContest === null ? contest : (this.state.expandedContest.contestId === contest.contestId ? null : contest)) });
    }

    chartExists() {
        return (this.props.screenContext.hasCharts && this.props.screenContext.screen != 'emps' && this.props.screenContext.screen != 'allemps')
    }

    numberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    convertToDisplay(type, number) {

        let endText = '';
        switch (type) {
            case 'MNY':
                endText += '$' + this.numberWithCommas(number);
                break;
            case 'INT':
                let newNum = parseFloat(number);
                if (newNum === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(0));
                }
                break;
            case 'PCT':
                let newNum1 = parseFloat(number);
                if (newNum1 === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(1)) + '%';
                }
                break;
            default:
                endText += this.numberWithCommas(number);
        }
        return endText;
    }

    handleChangeChart(chartName) {
        this.setState({ activeChart: chartName });
    }

    toggleChartHidden() {

        if (this.state.chartHidden) {
            this.chartEl.classList.remove('metrics-chart-hidden');
        } else {
            this.chartEl.classList.add('metrics-chart-hidden');
        }

        window.localStorage.setItem('chartHidden', !this.state.chartHidden);

        this.setState({ chartHidden: !this.state.chartHidden });
    }

    generateChartMenuItems() {
        let chartMenuItems = [];
        chartMenuItems.push((<MetricsChartMenuItem closeMenuOnClick onClick={this.handleChangeChart} chart="rollup" icon="short_text" text="Snapshot" add={null} />));
        chartMenuItems.push((<MetricsChartMenuItem closeMenuOnClick onClick={this.handleChangeChart} chart="bar" icon="equalizer" text="Bar Chart" add={null} />));
        //chartMenuItems.push((<MetricsChartMenuItem closeMenuOnClick onClick={this.handleChangeChart} chart="pie" icon="pie_chart" text="Pie Chart" add={null} />));
        chartMenuItems.push((<MetricsChartMenuItem closeMenuOnClick onClick={this.toggleChartHidden} icon="swap_vert" text="Collapse Chart" add={null} />));

        return chartMenuItems;
    }

    generateGoalItems() {

        this.goalSwitch = true;

        // if (this.props.activeGoals.length === 0 || !this.props.rightOptions.goals.active || this.props.rightOptions.goals.hold) {
        //     return <div className="metrics-right-category-container" style={{ height: '0rem' }}></div>;
        // }

        let goals = [];

        goals.push((<div className="metrics-right-white-title">{"Goals"}</div>));

        for (var i = 0; i < this.props.activeGoals.length; i++) {

            let numType = 'INT';
            if (this.props.activeGoals[i].blastData != undefined && this.props.activeGoals[i].blastData != null && this.props.activeGoals[i].blastData.length > 0) {
                numType = this.props.activeGoals[i].blastData[0].type;
            }
            // if (this.props.blastData[this.props.activeGoals[i].metricName] != undefined && this.props.blastData[this.props.activeGoals[i].metricName].length != 0) {
            //     numType = this.props.blastData[this.props.activeGoals[i].metricName][0].type;
            // } else {

            // }

            goals.push((<MetricsEngageErrorItem type='goal'>
            <MetricsGoalItem
                key={this.props.activeGoals[i].name + "|" + this.props.lastBlastReload}
                allBlastData={this.props.blastData}
                locationMap={this.props.locationMap}
                storeMap={this.props.storeMap}
                numType={numType}
                identity={this.props.activeGoals[i]}
                selectedDate={this.props.blastFilter.date}
                expandGoal={this.expandGoal}
                expanded={this.state.expandedGoal === null ? false : this.state.expandedGoal.goalId === this.props.activeGoals[i].goalId}
            />
            </MetricsEngageErrorItem>));
        }

        let wrapperStyle = {}
        wrapperStyle.height = ((this.props.activeGoals.length * 5.5) + (this.state.expandedGoal === null ? 0 : 11.35) + 4.2) + 'rem';
        if (this.props.activeGoals.length === 0 || !this.props.rightOptions.goals.active || this.props.rightOptions.goals.hold) {
            wrapperStyle.height = '0rem';
            wrapperStyle.opacity = '0';
            this.goalSwitch = false;
        }
        return (<div className="metrics-right-category-container" style={wrapperStyle}>{goals}</div>);
    }

    generateContestItems() {

        this.contestSwitch = true;

        let contests = [];

        let activeContestant = zzDataCache.myDataName === undefined ? null : zzDataCache.myDataName;
        let activeContestantScreens = ['emp', 'allemp']
        if (activeContestantScreens.includes(this.props.screenContext.screen)) {
            activeContestant = this.props.screenContext.groupKey;
        }

        let isBlurred = false;
        if (this.props.accountInfo != undefined && this.props.accountInfo != null && this.props.accountInfo.userType === 5) {
            isBlurred = this.props.accountInfo.isEmployeeBlurred === null ? false : this.props.accountInfo.isEmployeeBlurred;
        }

        contests.push((<div className="metrics-right-white-title">{"Contests"}</div>));

        let heightCounter = 3.65;

        for (var i = 0; i < this.props.activeContests.length; i++) {

            let expanded = this.state.expandedContest === null ? false : this.state.expandedContest.contestId === this.props.activeContests[i].contestId;

            let tmpActiveContestant = activeContestant;
            if (this.props.activeContests[i].identity.participantType === "loc" && ["distLoc", "loc"].includes(this.props.screenContext.screen)) {
                tmpActiveContestant = this.props.screenContext.groupKey;
            }

            contests.push((<MetricsEngageErrorItem type='contest'>
            <MetricsContestItem
                key={this.props.activeContests[i].contestId + "|" + this.props.lastBlastReload}
                contest={this.props.activeContests[i]}
                expandContest={this.expandContest}
                expanded={expanded}
                activeContestant={tmpActiveContestant}
                isBlurred={isBlurred}
                myDataName={zzDataCache.myDataName}
            />
            </MetricsEngageErrorItem>));

            heightCounter += (!expanded ? 4.7 : this.props.activeContests[i].type === 'raffle' ? 16.85 : 21.6) + 0.55;
        }

        let wrapperStyle = {}
        wrapperStyle.height = heightCounter + 'rem';
        if (this.props.activeContests.length === 0 || !this.props.rightOptions.contests.active || this.props.rightOptions.contests.hold) {
            wrapperStyle.height = '0rem';
            wrapperStyle.opacity = '0';
            this.contestSwitch = false;
        }

        return (<div className="metrics-right-category-container" style={wrapperStyle}>{contests}</div>);
    }

    generateClipboard() {

        this.clipboardSwitch = true;

        let clipboard = [];
        let cMetricItems = [];
        let heightCounter = 4.2;

        clipboard.push((<div className="metrics-right-white-title">{"Clipboard"}</div>));

        if (//this.props.selectedItems.length === 0 ||
            this.props.screenContext.groupKey === undefined ||
            this.props.unsearchedBlastData[this.props.screenContext.groupKey] === undefined) {
            return null;
        } else {

            let cMetric = this.props.unsearchedBlastData[this.props.screenContext.groupKey];

            let workingFlag = false;
            if (this.props.screenContext.screen === 'emps' || this.props.screenContext.screen === 'allemps') {
                for (var i = 0; i < cMetric.length; i++) {
                    if (cMetric[i].isWorking) {
                        workingFlag = true;
                    }
                }
            }

            for (var i = 0; i < cMetric.length; i++) {
                let isSelected = false;
                for (var j = 0; j < this.props.selectedItems.length; j++) {
                    if (this.props.selectedItems[j].name === cMetric[i].name) {
                        isSelected = true;
                    }
                }
                if (isSelected) {
                    cMetricItems.push((<MetricsEngageErrorItem type='card' screenContext={this.props.screenContext}>
                        <MetricsCardItem
                            key={cMetric[i].uId}
                            accountInfo={this.props.accountInfo}
                            hasDistricts={this.props.hasDistricts}
                            changeScreen={this.props.changeScreen}
                            changeScreenLong={this.props.changeScreenLong}
                            promptForLongData={this.props.promptForLongData}
                            isSideBySide={this.state.isSideBySide}
                            selectedItems={this.props.selectedItems}
                            toggleSelectedItem={this.props.toggleSelectedItem}
                            rotateDataMode={this.props.rotateDataMode}
                            dataMode={this.props.blastFilter.dataMode}
                            range={this.props.blastFilter.range}
                            isMetric={this.props.screenContext.isMetric}
                            screenContext={this.props.screenContext}
                            identity={cMetric[i]}
                            workingFlag={workingFlag}
                            isClipboard
                            isGroupsMode={this.props.isGroupsMode}
                        />
                    </MetricsEngageErrorItem>));

                    heightCounter += 4.6;
                }
            }
        }

        clipboard.push((
            <div className="metrics-right-regular-card-container">
                {cMetricItems}
            </div>));

        let wrapperStyle = {}
        wrapperStyle.height = heightCounter + 'rem';
        if (cMetricItems.length === 0 || !this.props.rightOptions.clipBoard.active || this.props.rightOptions.clipBoard.hold) {
            wrapperStyle.height = '0rem';
            wrapperStyle.opacity = '0';
            this.clipboardSwitch = false;
        }

        return (<div className="metrics-right-category-container" style={wrapperStyle}>{clipboard}</div>);
    }

    generatePeek() {

        this.peekSwitch = true;

        let peekJsx = [];
        let cMetricItems = [];
        let heightCounter = 4.2;

        peekJsx.push((<div className="metrics-right-white-title">{"Peek"}</div>));

        if (this.props.canPeek) {

            let cMetric = this.props.peekData;

            let workingFlag = false;
            if (this.props.peekScreenContext.screen === 'emps' || this.props.peekScreenContext.screen === 'allemps') {
                for (var i = 0; i < cMetric.length; i++) {
                    if (cMetric[i].isWorking) {
                        workingFlag = true;
                    }
                }
            }

            for (var i = 0; i < cMetric.length; i++) {
                cMetricItems.push((
                    <MetricsCardItem
                        key={cMetric[i].uId}
                        accountInfo={this.props.accountInfo}
                        hasDistricts={this.props.hasDistricts}
                        changeScreen={this.props.changeScreen}
                        changeScreenLong={this.props.changeScreenLong}
                        promptForLongData={this.props.promptForLongData}
                        isSideBySide={this.state.isSideBySide}
                        selectedItems={this.props.selectedItems}
                        toggleSelectedItem={this.props.toggleSelectedItem}
                        rotateDataMode={this.props.rotateDataMode}
                        dataMode={this.props.blastFilter.dataMode}
                        range={this.props.blastFilter.range}
                        isMetric={this.props.peekScreenContext.isMetric}
                        screenContext={this.props.peekScreenContext}
                        isGroupsMode={this.props.isGroupsMode}
                        identity={cMetric[i]}
                        workingFlag={workingFlag}
                    />
                ));

                heightCounter += 4.6;
            }

            peekJsx.push((
                <div className="metrics-right-regular-card-container">
                    {cMetricItems}
                </div>));
        }

        let wrapperStyle = {}
        wrapperStyle.height = heightCounter + 'rem';
        if (cMetricItems.length === 0 || !this.props.rightOptions.peek.active || this.props.rightOptions.peek.hold) {
            wrapperStyle.height = '0rem';
            wrapperStyle.opacity = '0';
            this.peekSwitch = false;
        }

        return (<div className="metrics-right-category-container" style={wrapperStyle}>{peekJsx}</div>);
    }

    renderChart(chartTitleText) {

        this.chartSwitch = true;

        if (!this.chartExists()) {
            this.chartSwitch = false;

            let wrapperStyle = { height: '0rem', opacity: '0' }
            return (<div className="metrics-right-category-container" style={wrapperStyle}></div>);
        }

        let chart = null;
        let dropDownJsx = null;
        let range = this.props.blastFilter.range;
        let dataMode = this.props.blastFilter.dataMode;
        let screen = this.props.screenContext.screen;
        let groupKey = this.props.screenContext.groupKey;
        let keys = Object.keys(this.props.blastData);
        let cNums = [];
        let lNums = [];
        let lNumsD = [];
        let lNumsP = [];
        let xNames = [];
        let singleBlastData;

        let fullQty = 0;

        let tmpType = '';
        let tmpIsAvg = false;
        if (keys.length > 0 && groupKey != undefined && this.props.blastData[groupKey] != undefined) {
            singleBlastData = this.props.blastData[groupKey];

            if (singleBlastData.length > 0) {
                tmpType = singleBlastData[0].type;
                tmpIsAvg = singleBlastData[0].isAvg;
            }

            let tempData = [];
            for (var i = 0; i < singleBlastData.length; i++) {
                for (var j = 0; j < this.props.selectedItems.length; j++) {
                    if (singleBlastData[i].name === this.props.selectedItems[j].name) {
                        tempData.push(singleBlastData[i]);
                    }
                }
            }

            let data = (this.props.selectedItems.length > 0 ? tempData : singleBlastData);

            if (screen === "dists" && (tmpType === 'PCT' || tmpIsAvg)) {
                cNums = _.map(data, (obj) => { return obj.cData[range] * obj.zzQty });
                lNums = _.map(data, (obj) => { return obj.lData[range] * obj.zzQty });
                lNumsD = _.map(data, (obj) => { return obj.lDataD[range] });
                lNumsP = _.map(data, (obj) => { return obj.lDataP[range] });
                xNames = _.map(data, (obj) => { return obj.name });
            } else {
                cNums = _.map(data, (obj) => { return obj.cData[range] });
                lNums = _.map(data, (obj) => { return obj.lData[range] });
                lNumsD = _.map(data, (obj) => { return obj.lDataD[range] });
                lNumsP = _.map(data, (obj) => { return obj.lDataP[range] });
                xNames = _.map(data, (obj) => { return obj.name });
            }

            fullQty = data.reduce((r, e) => { if (e.zzQty != undefined) { r += e.zzQty } return r; }, 0);
        }

        let xAxisJsx = null;
        let yAxisJsx = null;

        if (this.state.activeChart === 'bar') {
            let xIcon = null;
            let yIcon = null;

            switch (dataMode) {
                case 'N':
                    chart = this.chartHelper.generateProgressBarChart(xNames, cNums, lNums);
                    yIcon = '#'
                    break;
                case 'D':
                    yIcon = '+/-'
                    chart = this.chartHelper.generatePosNegBarChart(xNames, lNumsD);
                    break;
                case 'P':
                    yIcon = '%'
                    chart = this.chartHelper.generatePosNegBarChart(xNames, lNumsP);
                    break;
            }

            switch (this.props.screenContext.screen) {
                case 'locs':
                    xIcon = 'store_mall_directory';
                    break;
                case 'emps':
                    xIcon = 'person';
                    break;
                case 'allemps':
                    xIcon = 'person';
                    break;
            }

            xAxisJsx = <div className="material-icons chart-axis-icon-x">{xIcon}</div>
            yAxisJsx = <div className="chart-axis-icon-y">{yIcon}</div>

        } else if (this.state.activeChart === 'rollup') {
            switch (dataMode) {
                case 'N':
                    chart = this.chartHelper.generateRollupBarChart(cNums, lNums);
                    break;
                case 'D':
                    chart = this.chartHelper.generateRollupBarChart(cNums, lNums);
                    break;
                case 'P':
                    chart = this.chartHelper.generateRollupBarChart(cNums, lNums);
                    break;
            }

            chart.props.className = chart.props.className + " progress-bar-chart-container";

            let cyTotal = parseFloat(cNums.reduce((total, num) => { return total + num; }, 0).toFixed(2));
            let lyTotal = parseFloat(lNums.reduce((total, num) => { return total + num; }, 0).toFixed(2));

            if (tmpType === 'PCT' || tmpIsAvg) {
                if (screen === "dists") {
                    cyTotal = parseFloat((cyTotal / (fullQty > 0 ? fullQty : 1)).toFixed(2));
                    lyTotal = parseFloat((lyTotal / (fullQty > 0 ? fullQty : 1)).toFixed(2));
                } else {
                    cyTotal = parseFloat((cyTotal / (cNums.length > 0 ? cNums.length : 1)).toFixed(2));
                    lyTotal = parseFloat((lyTotal / (lNums.length > 0 ? lNums.length : 1)).toFixed(2));
                }
            }

            let perc = parseFloat(((cyTotal / lyTotal) * 100.0).toFixed(1)) - 100.0;
            if (isNaN(parseFloat(perc))) {
                perc = 0;
            } else if (!isFinite(perc)) {
                perc = 0;
            }
            perc = perc.toFixed(1);
            if (perc >= 0) {
                perc = '+' + perc;
            }
            let percClass = "right";
            perc += '%';

            let delta = parseFloat((cyTotal - lyTotal).toFixed(2));
            let deltaText = tmpType === 'PCT' ? Math.abs(delta).toFixed(1) + '' : this.convertToDisplay(tmpType, Math.abs(delta));
            if (delta >= 0) {
                deltaText = '+' + deltaText;
            } else {
                deltaText = '-' + deltaText;
            }

            let bottomRightSubClass = "bottom-right-sub";
            let subLabel = "LY";
            if (zzDataCache.settings.compareMode === "endOfLastPeriod" ||
                zzDataCache.settings.compareMode === "toDateLastPeriod" ||
                zzDataCache.settings.compareMode === "thisDayLastPeriod") {
                subLabel = "LP";
            } else if (zzDataCache.settings.compareMode === "targets") {
                subLabel = "gps_fixed";
                bottomRightSubClass = 'material-icons ' + bottomRightSubClass;
            }

            xAxisJsx = (
                <div className="chart-rollup-sub">
                    <div className="top-left-label">{'+/-'}</div>
                    <div className="bottom-left-label">{'%'}</div>
                    <div className="top-left">{deltaText}</div>
                    <div className="bottom-left">{perc}</div>
                    <div className="top-right">{this.convertToDisplay(tmpType, cyTotal)}<div className="top-right-sub">CY</div></div>
                    <div className="bottom-right">{this.convertToDisplay(tmpType, lyTotal)}<div className={bottomRightSubClass}>{subLabel}</div></div>
                    {/* <div className={percClass}>{perc}</div> */}
                </div>
            );

        } else if (this.state.activeChart === 'pie') {
            switch (dataMode) {
                case 'N':
                    chart = this.chartHelper.generateDoublePieChart(xNames, cNums, lNums);
                    break;
                case 'D':
                    chart = this.chartHelper.generateDoublePieChart(xNames, cNums, lNums);
                    break;
                case 'P':
                    chart = this.chartHelper.generateDoublePieChart(xNames, cNums, lNums);
                    break;
            }
        }

        let chartClass = 'metrics-right-chart-card-container';
        if (!this.state.chartHidden) {
            dropDownJsx = (
                <ZDropdownMenu
                    id="metrics-right-title-button-container"
                    className="metrics-right-title-button-container"
                    menuItems={this.generateChartMenuItems()}
                    isBlocked={true}
                // anchor={{
                //     x: DropdownMenu.HorizontalAnchors.INNER_RIGHT,
                //     y: DropdownMenu.VerticalAnchors.OVERLAP
                // }}
                // repositionOnScroll={false}
                >
                    <div className="metrics-right-title-button material-icons">more_vert</div>
                </ZDropdownMenu>
            );
        } else {
            chartClass += ' metrics-chart-hidden';
            dropDownJsx = (
                <div className="metrics-right-title-button-container" onClick={this.toggleChartHidden}><div className="metrics-right-title-button material-icons">swap_vert</div></div>
            );
        }

        let wrapperStyle = {}
        wrapperStyle.height = (this.state.chartHidden ? 4.05 : 16.85) + 'rem';
        if (!this.props.rightOptions.chart.active || this.props.rightOptions.chart.hold) {
            wrapperStyle.height = '0rem';
            wrapperStyle.opacity = '0';
            this.chartSwitch = false;
        }

        return (
            <div className="metrics-right-category-container" style={wrapperStyle}>
                <div className={chartClass} ref={(el) => { this.chartEl = el; }}>
                    <div className="metrics-right-title-container">
                        <div className="metrics-right-title">{chartTitleText}</div>
                        {dropDownJsx}
                    </div>
                    <div className="metrics-right-chart-container">
                        {chart}
                    </div>
                    {xAxisJsx}
                    {yAxisJsx}
                </div>
            </div>
        );
    }

    openAdLink() {
        if (this.state.adLink != '#' && this.state.adLink != '') {
            this.adService.clickContent(this.state.contentId);
            window.open(this.state.adLink, '_system');
        }
    }

    generateNoContentMessage() {

        let contentJsx = null;

        let isContent = true;
        let errorMessage = '';

        let screen = this.props.screenContext.screen;

        if (this.props.rightOptions.peek.active) {
            if (!this.peekSwitch) {
                isContent = false;

                if (screen != 'dist' && screen != 'distLoc' && screen != 'loc' && screen != 'emp' && screen != 'allemp') {
                    let itemText = 'Item';
                    let possessiveText = 'Its'
                    switch (screen) {
                        case 'dists': itemText = 'District'; break;
                        case 'distLocs': itemText = 'Location'; break;
                        case 'locs': itemText = 'Location'; break;
                        case 'emps': itemText = 'Employee'; possessiveText = 'Their'; break;
                        case 'allemps': itemText = 'Employee'; possessiveText = 'Their'; break;
                    }

                    errorMessage = 'Select One ' + itemText + ' on the Left to Peek at ' + possessiveText + ' Metrics';
                }
            }
        } else if (!this.chartSwitch && !this.goalSwitch && !this.contestSwitch && !this.clipboardSwitch) {
            isContent = false;

            if (screen != 'dist' && screen != 'distLoc' && screen != 'loc' && screen != 'emp' && screen != 'allemp') {
                let itemText = 'Items';
                switch (screen) {
                    case 'dists': itemText = 'Districts'; break;
                    case 'distLocs': itemText = 'Locations'; break;
                    case 'locs': itemText = 'Locations'; break;
                    case 'emps': itemText = 'Employees'; break;
                    case 'allemps': itemText = 'Employees'; break;
                }
                if (this.props.rightOptions.clipBoard.active && !this.props.rightOptions.clipBoard.hold) {
                    errorMessage = 'Select ' + itemText + ' on the Left to Compare Them Here';
                }
            }
        }

        if (!isContent) {

            if (errorMessage === '') {
                errorMessage = 'Nothing to Inspect';
            }

            contentJsx = (
                <div className="error-message-outer">
                    <div className="error-image-container">
                        <div className="error-image material-icons">vertical_split</div>
                    </div>
                    <div className="error-message-container">
                        <div className="error-message">{errorMessage}</div>
                    </div>
                </div>
            )
        }

        return contentJsx;
    }


    render() {

        if (this.props.blastData === undefined || Object.keys(this.props.blastData).length === 0 ||
            this.props.blastData[this.props.screenContext.groupKey] === undefined || this.props.blastData[this.props.screenContext.groupKey].length === 0) {
            return (
                <div className="metrics-right-outer" style={this.props.style}>
                    <div className="error-message-outer">
                        <div className="error-image-container">
                            <div className="error-image material-icons">vertical_split</div>
                        </div>
                        <div className="error-message-container">
                            <div className="error-message">Details View Unavailable</div>
                        </div>
                    </div>
                </div>
            );
        }

        let titleText = "";

        let timeText = "";
        switch (this.props.blastFilter.range) {
            case "CUR": timeText = "Day"; break;
            case "WTD": timeText = "Week"; break;
            case "MTD": timeText = "Month"; break;
            case "QTD": timeText = "Quarter"; break;
            case "YTD": timeText = "Year"; break;
        }

        // switch (zzDataCache.settings.compareMode) {
        //     case "lastYear": titleText = "Last Year " + (timeText === "Day" ? "Daily" : timeText + " to Date"); break;
        //     case "endOfLastPeriod": titleText = "Last Period End of " + timeText; break;
        //     case "toDateLastPeriod": titleText = "Last Period " + (timeText === "Day" ? "" : timeText + " ") + "to Date"; break;
        //     case "thisDayLastPeriod": titleText = "This Day Last " + (timeText === "Day" ? "Period" : timeText); break;
        //     case "targets": titleText = timeText + " Targets"; break;
        // }
        switch (zzDataCache.settings.compareMode) {
            case "lastYear": titleText = "Year Over Year"; break;
            case "toDateLastPeriod": titleText = (timeText === "Day" ? "Previous Day" : timeText + " to Date"); break;
            case "endOfLastPeriod": titleText = "Entire " + timeText; break;
            case "thisDayLastPeriod": titleText = "Same Day"; break;
            case "targets": titleText = timeText + " Targets"; break;
        }

        let regTitleText = this.props.screenContext.headerText + " (" + titleText + ")";

        var chart = this.renderChart(titleText);
        let goalCards = this.generateGoalItems();
        let contestCards = this.generateContestItems();
        let clipboardCard = this.generateClipboard();
        let peekCard = this.generatePeek();

        let noContentJsx = this.generateNoContentMessage();

        let hasCharts = this.chartExists();
        let bottomRightStyle = {};
        if (this.props.drillingIn != 'still') {
            bottomRightStyle.opacity = '0';
        }

        let outerClass = "metrics-right-outer";

        return (
            <div className={outerClass} ref={(outer) => { this.viewOuter = outer }} style={this.props.style}>
                <div className="metrics-right-bottom-right-container" style={bottomRightStyle}>
                    {chart}
                    {contestCards}
                    {goalCards}
                    {clipboardCard}
                    {peekCard}
                    {noContentJsx}
                    {/* <div className="metrics-right-regular-card-container">
                        <img onClick={this.openAdLink} className="metrics-central-advertisement-card" src={this.state.adImage} />
                    </div> */}
                </div>
            </div>
        );
    }
}